import { LaunchDarklyProvider } from '@navinc/base-react-components'
import { global } from '@navinc/utils'
import { useAccount } from '../hooks/apollo/use-account.js'

const { CLIENT_LAUNCH_DARKLY_CLIENT_SIDE_ID } = global?.process?.env ?? {}

const Loader = () => <div /> // Using this empty div rather than our real Loader component will prevent 2 loaders from showing

export const LaunchDarklyProviderWithData = ({ children }) => {
  const { account: { id: enterpriseUuid } = {}, loading } = useAccount()

  if (loading) return <Loader />

  return (
    <LaunchDarklyProvider
      clientSideID={CLIENT_LAUNCH_DARKLY_CLIENT_SIDE_ID}
      context={{
        kind: 'user',
        // key is populated by the SDK if anonymous is true
        // https://docs.launchdarkly.com/sdk/client-side/javascript/migration-2-to-3#understanding-changes-to-anonymous-users
        ...(enterpriseUuid && { key: enterpriseUuid }),
        ...(!enterpriseUuid && { anonymous: true }),
        enterpriseUuid,
        // TODO: remove userCurrentTime when its verified we don't use for any experiments.
        userCurrentTime: global.serverCurrentTime,
      }}
      LoadingContent={Loader}
      options={{
        sendEventsOnlyForVariation: true,
      }}
    >
      {children}
    </LaunchDarklyProvider>
  )
}
